module.exports = __webpack_public_path__ + "img/page.fa8af38e.png";